exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".van-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,.7);\n}", "", {"version":3,"sources":["D:/WenZhouBangZhang/BZQD/node_modules/vant/es/overlay/D:/WenZhouBangZhang/BZQD/node_modules/vant/es/overlay/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iCAAiC;CAClC","file":"index.css","sourcesContent":[".van-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,.7);\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./node_modules/px2rem-loader??ref--5-3!./node_modules/vant/es/overlay/index.css
// module id = 8fa4
// module chunks = 170